import React, {Component, PropTypes} from 'react'

export class ProfileListItem extends Component {

  static propTypes = { profile: PropTypes.object.isRequired }

  render () {
    const {profile} = this.props;
    return (
      <div className="profile list-item">
        <div
          className="list-item__avatar"
          style={{backgroundImage: profile.avatarUrl && 'url('+profile.avatarUrl+')'}}
        />
        <div className="list-item__content">
          <div className="list-item__name">
            {profile.name}
          </div>
          <div className="list-item__description">
            {profile.description}
          </div>
        </div>
      </div>
    );
  }
}
